import React, { useEffect, useRef, useState } from "react";
import { getApiCall, postApiCall, postFormApiCall } from "../../utils/api";
import MaterialTable from "material-table";
import tableIcons from "../component/MaterialIcon";
import { Button, ThemeProvider, createTheme } from "@mui/material";
import { Modal } from "@material-ui/core";
import {
  Close,
  Delete,
  Edit,
  RemoveRedEye,
  ViewAgenda,
} from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import stateList from "../../data/states.json";
import Select from "react-select";

const permissionLevelList = [
  { id: 1, name: "State Level" },
  { id: 2, name: "City Level" },
];
const AddUsers = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [levelId, setLevelId] = useState("");

  const [userName, setUserName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [permissionLevel, setPermissionLevel] = useState("");
  const [stateLevel, setStateLevel] = useState([]);
  const options = stateList.states.map((state) => ({
    value: state.state_code,
    label: state.name,
  }));

  // city
  const [cityLevelState, setCityLevelState] = useState("");
  const [cityLevel, setCityLevel] = useState([]);
  const [addedStateCityPairs, setAddedStateCityPairs] = useState([]);
  const selectedStateObj = stateList.states.find(
    (state) => state.state_code === cityLevelState
  );

  const cityOptions =
    selectedStateObj?.cities.map((city) => ({
      value: city,
      label: city,
    })) || [];

  const handleAdd = () => {
    if (!cityLevelState || cityLevel.length === 0) return;

    // Find the index of the state in addedStateCityPairs
    const existingStateIndex = addedStateCityPairs.findIndex(
      (entry) => entry.state === cityLevelState
    );

    if (existingStateIndex === -1) {
      // State is not present, add new entry
      const newEntry = {
        state: cityLevelState,
        cities: cityLevel,
      };
      setAddedStateCityPairs((prev) => [...prev, newEntry]);
    } else {
      // State already exists, update cities without duplicates
      setAddedStateCityPairs((prev) => {
        const updatedEntries = [...prev];
        const existingState = updatedEntries[existingStateIndex];

        // Add only cities that are not already in the state's cities list
        const newCities = cityLevel.filter(
          (city) => !existingState.cities.includes(city)
        );

        // Update the cities for the existing state
        existingState.cities = [...existingState.cities, ...newCities];
        return updatedEntries;
      });
    }

    // Optional: reset state and city selections
    // setCityLevelState("");
    // setCityLevel([]);
  };

  const handleRemove = (index) => {
    setAddedStateCityPairs((prev) => {
      const updatedEntries = [...prev];
      updatedEntries.splice(index, 1); // Remove the entry at the given index
      return updatedEntries;
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    // setLoading(true);
    // const classes = await getApiCall("classes/get-all");
    // setClassList(classes.data);

    const res = await getApiCall("admin/get-level-users");
    console.log("Asdasd", res);

    setData(res.data);
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", userName);
    formData.append("email", email);
    formData.append("permission_level", permissionLevel);
    formData.append("phone", phone);
    formData.append("password", password);
    formData.append("id", levelId);

    if (permissionLevel === "1") {
      // state
      formData.append("data", JSON.stringify(stateLevel));
    } else {
      // state city
      formData.append("data", JSON.stringify(addedStateCityPairs));
    }

    let res = {};
    if (levelId === "") {
      res = await postFormApiCall("admin/register-level-admin", formData);
    } else {
      res = await postFormApiCall("admin/update-level-admin", formData);
    }
    setLoading(false);
    if (res.success === false) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });
    setLevelId("");
    setUserName("");
    setPhone("");
    setPassword("");
    setEmail("");
    setPermissionLevel("");
    setStateLevel([]);
    setCityLevelState("");
    setCityLevel([]);
    setAddedStateCityPairs([]);
    setLevelId("");
    fetchData();
  };

  const handleStatusChange = async (rowData, newStatus) => {
    const updatedStatus = newStatus === "Active";

    new Swal({
      title: "Are you sure, you want to make it " + newStatus + "?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("admin/level-admin-update-status", {
          id: rowData.id,
          status: updatedStatus,
        });
        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        fetchData();
      }
    });
  };

  const columns = [
    { title: "Sl. no", field: "serial", width: "10%" },
    {
      title: "Name",
      field: "user_name",
    },
    {
      title: "Email",
      field: "user_email",
    },
    {
      title: "Phone",
      field: "user_phone",
    },
    {
      title: "Permission Level",
      field: "permission_level",
      render: (rowData) => (
        <button
          onClick={() => handlePermissionClick(rowData)}
          style={{
            background: "none",
            border: "none",
            color: "#007bff",
            textDecoration: "underline",
            cursor: "pointer",
            padding: 0,
          }}
        >
          {rowData.permission_level === 1 ? "State Level" : "City Level"}
        </button>
      ),
    },
    {
      title: "Status",
      field: "is_active",
      render: (rowData) => (
        <select
          value={rowData.is_active ? "Active" : "Inactive"}
          onChange={(e) => handleStatusChange(rowData, e.target.value)}
        >
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      ),
    },
  ];

  const [open, setOpen] = useState(false);
  const [viewLevel, setViewLevel] = useState("");
  const [showData, setShowData] = useState([]);
  const handlePermissionClick = (rowData) => {
    setViewLevel(rowData.permission_level);
    setShowData(JSON.parse(rowData.level_data));
    setOpen(true);
  };

  const handleEdit = async (rowData) => {
    setLevelId(rowData.id);
    setUserName(rowData.user_name);
    setPhone(rowData.user_phone);
    setEmail(rowData.user_email);
    setPermissionLevel(rowData.permission_level.toString());
    const parsedData = JSON.parse(rowData.level_data);
    if (rowData.permission_level == "1") {
      setStateLevel(parsedData);
    }
    if (rowData.permission_level == "2") {
      setAddedStateCityPairs(parsedData);
      const state = parsedData[0].state;
      const cities = parsedData[0].cities;
      setCityLevelState(state);
      setCityLevel(cities);
    }

    inputRef.current.focus();
    const input = document.getElementById("boardInput");
    input.focus();
  };

  //   const handleDelete = async (rowData) => {
  //     new Swal({
  //       title: "Are you sure?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       confirmButtonText: "Yes",
  //     }).then(async (result) => {
  //       if (result.isConfirmed) {
  //         const res = await postApiCall("videos/delete", { id: rowData.id });
  //         if (res.success === false) {
  //           return Swal.fire({
  //             title: "Error",
  //             text: res.message,
  //             icon: "error",
  //           });
  //         }
  //         Swal.fire({
  //           title: "Successful",
  //           text: res.message,
  //           icon: "success",
  //         });
  //         fetchData();
  //       }
  //     });
  //   };

  return (
    <div>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            width: "60%",
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <h3>Permission Data</h3>

          {viewLevel == "1" ? (
            Array.isArray(showData) && showData.length > 0 ? (
              <>
                States:{" "}
                {showData.map((pair, index) => (
                  <div key={index}>{pair}</div>
                ))}
              </>
            ) : (
              <p>No entries added yet.</p>
            )
          ) : showData && showData.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>State</th>
                  <th>City</th>
                </tr>
              </thead>
              <tbody>
                {showData.map((pair, index) => (
                  <tr key={index}>
                    <td>{pair.state}</td>
                    <td>
                      {pair.cities.map((val, i) => (
                        <span key={i}>
                          {val}
                          {i < pair.cities.length - 1 ? ", " : ""}
                        </span>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No entries added yet.</p>
          )}
        </div>
      </Modal>

      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Add Users</h4>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Users</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">Add User</h3>
                  </div>
                  <form onSubmit={handleSubmit} enctype="multipart/form-data">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">User Name</label>
                            <input
                              type="text"
                              onChange={(e) => setUserName(e.target.value)}
                              className="form-control"
                              id="userName"
                              placeholder="Enter Name"
                              ref={inputRef}
                              value={userName}
                              name="username"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">User Email Id</label>
                            <input
                              type="text"
                              onChange={(e) => setEmail(e.target.value)}
                              className="form-control"
                              id="email"
                              placeholder="Enter Email ID"
                              ref={inputRef}
                              value={email}
                              name="email"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">Phone</label>
                            <input
                              type="tel"
                              onChange={(e) => setPhone(e.target.value)}
                              className="form-control"
                              id="phone"
                              placeholder="Enter Phone number"
                              ref={inputRef}
                              value={phone}
                              name="phone"
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group position-relative">
                            <label htmlFor="password">Password</label>
                            <input
                              type={showPassword ? "text" : "password"}
                              onChange={(e) => setPassword(e.target.value)}
                              className="form-control"
                              id="password"
                              placeholder="Enter Password"
                              ref={inputRef}
                              value={password}
                              name="password"
                            />
                            <span
                              onClick={() => setShowPassword((prev) => !prev)}
                              style={{
                                position: "absolute",
                                top: "45px",
                                right: "10px",
                                cursor: "pointer",
                                zIndex: 2,
                                color: "#888",
                              }}
                            >
                              {showPassword ? <Close /> : <RemoveRedEye />}
                            </span>
                          </div>
                        </div>

                        {/* permission */}
                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">Permission Level</label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setPermissionLevel(e.target.value);
                                // onModuleChange(e.target.value);
                              }}
                              required
                              value={permissionLevel}
                              name="permissionLevel"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {permissionLevelList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12"></div>

                        {/* id state level */}
                        {permissionLevel === "1" && (
                          <div className="col-md-4 col-sm-12">
                            <div className="form-group">
                              <label
                                htmlFor="stateLevel"
                                className="form-label"
                              >
                                Select States
                              </label>
                              <Select
                                id="stateLevel"
                                name="stateLevel"
                                options={options}
                                isMulti
                                value={options.filter((option) =>
                                  stateLevel.includes(option.value)
                                )}
                                onChange={(selectedOptions) =>
                                  setStateLevel(
                                    selectedOptions.map((opt) => opt.value)
                                  )
                                }
                                classNamePrefix="react-select"
                              />
                              <small className="form-text text-muted">
                                Selected States: {stateLevel.join(", ")}
                              </small>
                            </div>
                          </div>
                        )}
                        {permissionLevel === "2" && (
                          <>
                            <div className="col-md-4 col-sm-12">
                              <div className="form-group">
                                <label
                                  htmlFor="cityLevelState"
                                  className="form-label"
                                >
                                  Select States
                                </label>
                                <Select
                                  id="cityLevelState"
                                  name="cityLevelState"
                                  options={options}
                                  value={options.find(
                                    (option) => cityLevelState === option.value
                                  )}
                                  onChange={(selectedOption) => {
                                    setCityLevelState(
                                      selectedOption?.value || ""
                                    );
                                    setCityLevel([]);
                                  }}
                                  classNamePrefix="react-select"
                                />
                              </div>
                            </div>

                            <div className="col-md-4 col-sm-12">
                              <div className="form-group">
                                <label htmlFor="cities" className="form-label">
                                  Select Cities
                                </label>
                                <Select
                                  id="cities"
                                  name="cities"
                                  options={cityOptions}
                                  isMulti
                                  value={cityOptions.filter((option) =>
                                    cityLevel.includes(option.value)
                                  )}
                                  onChange={(selectedOptions) =>
                                    setCityLevel(
                                      selectedOptions.map((opt) => opt.value)
                                    )
                                  }
                                  classNamePrefix="react-select"
                                />
                                <small className="form-text text-muted">
                                  Selected: {cityLevel.join(", ")}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-4 col-sm-12 mt-4">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleAdd}
                              >
                                Add +
                              </button>
                            </div>
                            <div className="col-12 mt-4">
                              <h5>Added Entries</h5>
                              {addedStateCityPairs &&
                              addedStateCityPairs.length > 0 ? (
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th>State</th>
                                      <th>City</th>
                                      <th>Action</th>{" "}
                                      {/* Added column for action */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {addedStateCityPairs.map((pair, index) => (
                                      <tr key={index}>
                                        <td>{pair.state}</td>
                                        <td>
                                          {pair.cities.map((val, i) => (
                                            <span key={i}>
                                              {val}
                                              {i < pair.cities.length - 1
                                                ? ", "
                                                : ""}
                                            </span>
                                          ))}
                                        </td>
                                        <td>
                                          {/* Remove button */}
                                          <button
                                            className="btn btn-danger"
                                            onClick={() => handleRemove(index)}
                                          >
                                            Remove
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : (
                                <p>No entries added yet.</p>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary">
                        submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                      icons={tableIcons}
                      title="Users"
                      columns={columns}
                      data={data}
                      onRowClick={(evt, selectedRow) =>
                        setSelectedRow(selectedRow.tableData.id)
                      }
                      options={{
                        exportButton: true,
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "rgb(0 123 255)",
                          color: "#FFF",
                          fontSize: 18,
                        },
                        rowStyle: (rowData, index) => ({
                          backgroundColor:
                            selectedRow === rowData.tableData.id
                              ? "#d3d4d1"
                              : index % 2 !== 0
                              ? "#EEE"
                              : "#FFF",
                        }),
                      }}
                      actions={[
                        {
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Edit />
                            </span>
                          ),
                          tooltip: "Edit",
                          onClick: (event, rowData) => handleEdit(rowData),
                        },
                        // (rowData) => ({
                        //   icon: () => (
                        //     <span style={{ color: "#5656ce" }}>
                        //       <Delete />
                        //     </span>
                        //   ),
                        //   tooltip: "Delete",
                        //   onClick: (event, rowData) => handleDelete(rowData),
                        // }),
                      ]}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
    </div>
  );
};

export default AddUsers;
